export default __webpack_public_path__ + "static/media/avatar.bae3f235.jpg";